import { Grid, LinearProgress, Typography } from "@mui/material";
import type { FC } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import CancelButton from "../../components/cancelButton/CancelButton";
import type { ProductFormState } from "./editProduct/ProductEdit";
import ProductEdit from "./editProduct/ProductEdit";
import ProductOptionsView from "./editProduct/ProductOptionsView";
import type { ProductResponse } from "./productsApi";
import { useProduct } from "./useProduct";

const ReadOnlyProductView: FC<{ readonly product: ProductResponse }> = ({ product }) => {
  const { control } = useForm<ProductFormState>({ defaultValues: product });
  return <ProductEdit control={control} providerId={product.provider.id} disabled />;
};

const ReadOnlyProductPage = () => {
  const navigate = useNavigate();
  const { product, isLoading } = useProduct();

  if (isLoading) {
    return (
      <Grid container>
        <Grid size={12}>
          <LinearProgress data-testid="loading-indicator" />
        </Grid>
      </Grid>
    );
  }

  if (!product) {
    return (
      <Grid
        container
        spacing={2}
        sx={{
          marginTop: 1,
          marginBottom: 1,
        }}
      >
        <Typography
          sx={{
            margin: 2,
          }}
        >
          Taki produkt nie istnieje
        </Typography>
      </Grid>
    );
  }

  return (
    <Grid
      container
      spacing={2}
      sx={{
        marginTop: 1,
        marginBottom: 1,
        paddingLeft: 1,
        paddingRight: 1,
      }}
    >
      <ReadOnlyProductView product={product} />
      <Grid
        size={12}
        container
        sx={{
          justifyContent: "flex-end",
        }}
      >
        <CancelButton onClick={() => navigate("/admin/products")} />
      </Grid>
      <Grid size={12}>
        <ProductOptionsView productId={product.id} provider={product.provider} options={product.options} />
      </Grid>
    </Grid>
  );
};

export default ReadOnlyProductPage;
